import React, { useState } from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";
import { FaChevronDown } from "react-icons/fa6";

const LocationBenefits = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  //   const [show, setShow] = useState(window.innerWidth > 768);
  const [accordItems, setAccordItems] = useState([
    {
      title: "NATURE & RECREATION",
      list: [
        "Yogi hill – 2.5 km.",
        "Mama Bhanja – 2.9 km.",
        "Sardar Pratap Singh Garden- 2.4 km.",
        "Cypress garden – 2 km.",
        "Deshmukh Garden – 4.8 km.",
        "Shri Anand Dighe Garden – 2 km.",
      ],
      expanded: false,
    },
    {
      title: "CONNECTIVITY",
      list: [
        "Upcoming Metro (Line 4) - 2.5 km.",
        "Eeastern Express Highway - 3.2 km.",
        "LBS Marg - 9.2 km.",
        "Mulund Check Naka - 2.9 km.",
        "Thane Stn. - 2.5 km.",
        "Mulund Stn. - 2.5 km.",
      ],
      expanded: false,
    },
    {
      title: "EDUCATIONAL INSTITUTION",
      list: [
        "Finland International School - 350 mt.",
        "Billabong High International School – 3.7 km.",
        "DAV international school proposed – 3.2 km.",
        "Sulochanadevi Singhania school – 4 km.",
        "NES International school - 1.3 km.",
      ],
      expanded: false,
    },
    {
      title: "HEALTHCARE",
      list: [
        "Shree Mahavir Jain hospital – 1.9 km.",
        "Fortis hospital – 4.6 km.",
        "Platinum hospital – 1.9 km.",
        "Jupiter hospital – 4.3 km.",
        "Bethany hospital – 5.5 km.",
      ],
      expanded: false,
    },
    {
      title: "IT PARKS",
      list: [
        "Ashar IT Park - 1.6 km.",
        "Centrum - 1.1 km.",
        "Oriana Business Park - 1 km.",
        "Lodha Supreme - 900 mt.",
        "Opal Square IT Park - 1.6 km",
      ],
      expanded: false,
    },
    {
      title: "LIFESTYLE",
      list: [
        "R Mall - 1.6 km.",
        "Viviana Mall - 4.6 km.",
        "Korum Mall - 3.2 km.",
        "Kalidas - 3.1 km.",
        "MAJOR CITY HUBS",
        "Powai – 15 km.",
        "Mumbai International airport – 22 km.",
        "BKC – 26 km.",
      ],
      expanded: false,
    },
  ]);
  const handleToggleAccordion = (index) => {
    setAccordItems((prevItems) =>
      prevItems.map((item, i) =>
        i === index ? { ...item, expanded: !item.expanded } : item
      )
    );
  };
  return (
    <section className="section shadow-sm lazyloaded" id="pricing">
      <span className="section-link"></span>
      <div className="split-2">
        <div className="content part">
          <div>
            <h2 className="head text-capitalize text-center">
              {project} - Location Benefits
            </h2>
            {/* <p className="">
              Nestled in the heart of Panch Pakhadi, Thane City Centre,
              Hiranandani Belicia stands as an epitome of seamless urban living
              fused with serene luxury. Its strategic location offers
              unparalleled connectivity to Mumbai and major business hubs,
              ensuring that daily commutes are effortless and time-efficient.
              Whether it's accessing the Eastern Express Highway, Ghodbunder
              Road, or Thane Railway{" "}
              {!show && (
                <span
                  className="mobile-only-expansion"
                  onClick={() => {
                    setShow(!show);
                  }}
                >
                  ..read more
                </span>
              )}{" "}
              {show && (
                <span className="extra-content">
                  Station, residents benefit from an exceptionally
                  well-connected neighborhood. The upcoming metro corridors
                  further enhance accessibility, making travel across the city
                  even more convenient. <br /> Beyond connectivity, Hiranandani
                  Belicia places you at the heart of a thriving lifestyle
                  ecosystem. With renowned malls, fine-dining restaurants, and
                  entertainment hubs just minutes away, residents can enjoy a
                  vibrant social life without stepping too far from home. The
                  area is also home to some of the best schools, hospitals, and
                  recreational spaces, ensuring that every aspect of
                  life—education, healthcare, leisure, and wellness—is taken
                  care of. Despite being in the midst of a bustling city, the
                  project’s thoughtfully designed residences and open spaces
                  provide a peaceful sanctuary, making it the ultimate
                  destination for refined and balanced living.{" "}
                  {show && (
                    <span
                      className="mobile-only-expansion"
                      onClick={() => {
                        setShow(!show);
                      }}
                    >
                      read less
                    </span>
                  )}{" "}
                </span>
              )}
            </p> */}
            <p>
              Nestled in Shree Nagar, Wagle Estate, Thane, Ashar Merac enjoys a
              prime location within the Mulund-Thane Corridor (MTC), offering
              seamless connectivity to major business districts, educational
              institutions, healthcare centers, and entertainment hubs.
              Strategically positioned near Eastern Express Highway, the project
              ensures effortless travel to Mumbai, Navi Mumbai, and other key
              regions. <br /> With Wagle Estate, a thriving industrial and
              commercial hub, just minutes away, residents can enjoy a
              well-connected urban lifestyle while staying close to nature, with
              Yogi Hills and Sanjay Gandhi National Park (SGNP) providing a
              serene backdrop.
            </p>

            {/* <ul>
              <li>
                Spacious & Smart Layouts – Open-plan designs with high ceilings
                & wide balconies.
              </li>
              <li>
                Maximized Natural Light – Expansive glass walls & large windows
                enhance brightness.
              </li>
              <li>
                Private Outdoor Spaces – Sky terraces & exclusive balconies
                offer a resort-style living experience.
              </li>
              <li>
                Future-Ready Homes – Smart home automation & sustainable
                architecture blend convenience with luxury.
              </li>
            </ul> */}
          </div>
          <div className="price-button">
            <button
              class="btn btn-sm btn-info effetGradient effectScale enqModal"
              onClick={handleShowModal}
            >
              Explore Connectivity
            </button>
          </div>
        </div>
        <div className="image part">
          <img src="images/lb.jpg" width="100%" alt="" />
          <span>
            <span className="buttonn d-flex" onClick={handleShowModal}>
              Get Location & Connectivity Details
            </span>
          </span>
        </div>
      </div>
      <div className="accord">
        {accordItems.map((accordItem, index) => (
          <div key={index} className="accord-item">
            <div
              className="accord-head"
              onClick={() => handleToggleAccordion(index)}
            >
              <div className="accord-itme-title">
                <b>{accordItem.title}</b>
              </div>
              <div className="iconn">
                <FaChevronDown
                  style={{ rotate: accordItem.expanded ? "180deg" : "" }}
                />
              </div>
            </div>
            {accordItem.expanded && (
              <div className="accord-body">
                <ul>
                  {accordItem.list.map((listItem, index) => (
                    <li>{listItem}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};
export default LocationBenefits;
